import { useEffect } from "react";
import { PropTypes } from "prop-types";
import { isEqual } from "lodash";
import { useWatch } from "react-hook-form";
import { t } from "@/i18n-js/instance";
import { SectionCard } from "@circle-react-uikit/SectionCard";
import { Tabs } from "@circle-react-uikit/Tabs";
import { WelcomeBannerForm } from "./WelcomeBannerForm";

const TABS = {
  logged_in: t("home_page.edit_form.logged_in"),
  logged_out: t("home_page.edit_form.logged_out"),
};

export const WelcomeBanner = ({ initialFormValues, setIsPristine }) => {
  const formState = useWatch();

  useEffect(() => {
    if (!isEqual(formState, initialFormValues)) {
      setIsPristine(false);
    }
  }, [formState]);

  return (
    <div
      className="flex h-full w-full flex-col items-center gap-4 md:py-8"
      data-testid="customize-banners-options"
    >
      <SectionCard title={t("home_page.welcome_banner")} variant="fullScreen">
        <section className="flex-1">
          <Tabs variant="underline-sm" defaultValue={TABS.logged_in}>
            <template label={TABS.logged_in}>
              <div className="py-6" role="tabpanel">
                <WelcomeBannerForm isLoggedIn />
              </div>
            </template>
            <template label={TABS.logged_out}>
              <div className="py-6" role="tabpanel">
                <WelcomeBannerForm isLoggedIn={false} />
              </div>
            </template>
          </Tabs>
        </section>
      </SectionCard>
    </div>
  );
};

WelcomeBanner.propTypes = {
  initialFormValues: PropTypes.object,
  setIsPristine: PropTypes.func,
};
